import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { registrarUsuario } from '../api/backend_v2';
import './RegisterForm.css';
import { EyeSlashIcon, EyeIcon } from '@heroicons/react/24/outline';

const RegisterForm = ({ onRegisterSuccess, onGoToLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    nombre_completo: '',
    contraseña: '',
    confirmar_contraseña: '',
    rol: 'operario'
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validarFormulario = () => {
    const errores = [];

    if (!formData.email.trim()) {
      errores.push('Email es requerido');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errores.push('Email inválido');
    }

    if (!formData.nombre_completo.trim()) {
      errores.push('Nombre completo es requerido');
    }

    if (!formData.contraseña) {
      errores.push('Contraseña es requerida');
    } else if (formData.contraseña.length < 6) {
      errores.push('La contraseña debe tener al menos 6 caracteres');
    }

    if (formData.contraseña !== formData.confirmar_contraseña) {
      errores.push('Las contraseñas no coinciden');
    }

    return errores;
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    const errores = validarFormulario();
    if (errores.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Errores en el formulario',
        html: errores.map(e => `<p>• ${e}</p>`).join('')
      });
      return;
    }

    setLoading(true);
    try {
      // No enviar la confirmación de contraseña al backend
      const datosRegistro = {
        email: formData.email.trim(),
        nombre_completo: formData.nombre_completo.trim(),
        contraseña: formData.contraseña,
        rol: formData.rol
      };

      const response = await registrarUsuario(datosRegistro);

      Swal.fire({
        icon: 'success',
        title: '¡Registro exitoso!',
        html: '<p>Tu cuenta ha sido creada correctamente.</p><p style="color: #ff6b6b; margin-top: 10px;"><strong>⏳ Tu cuenta está pendiente de activación por un administrador.</strong></p><p>Una vez activada podrás iniciar sesión.</p>',
        timer: 4000,
        showConfirmButton: false
      });

      // Redirigir a login después de 4 segundos
      setTimeout(() => {
        if (onGoToLogin) onGoToLogin();
      }, 4000);

    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error al registrar',
        text: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <div className="register-header">
          <h1>Wolf Eye Optical System</h1>
          <p>Crear Cuenta</p>
        </div>

        <form onSubmit={handleRegister} className="register-form">
          <div className="form-group">
            <label htmlFor="nombre_completo">Nombre Completo</label>
            <input
              id="nombre_completo"
              type="text"
              name="nombre_completo"
              value={formData.nombre_completo}
              onChange={handleChange}
              placeholder="Tu nombre completo"
              disabled={loading}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="tu@email.com"
              disabled={loading}
            />
          </div>


          <div className="form-group">
            <label htmlFor="contraseña">Contraseña</label>
            <div className="password-input">
              <input
                id="contraseña"
                type={showPassword ? 'text' : 'password'}
                name="contraseña"
                value={formData.contraseña}
                onChange={handleChange}
                placeholder="••••••••"
                disabled={loading}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
              >
                {showPassword ? <EyeSlashIcon className="w-6 h-6 text-gray-500" /> : <EyeIcon className="w-6 h-6 text-blue-500" />}
              </button>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirmar_contraseña">Confirmar Contraseña</label>
            <div className="password-input">
              <input
                id="confirmar_contraseña"
                type={showConfirmPassword ? 'text' : 'password'}
                name="confirmar_contraseña"
                value={formData.confirmar_contraseña}
                onChange={handleChange}
                placeholder="••••••••"
                disabled={loading}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                disabled={loading}
              >
                {showConfirmPassword ? <EyeSlashIcon className="w-6 h-6 text-gray-500" /> : <EyeIcon className="w-6 h-6 text-blue-500" />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="register-button"
            disabled={loading}
          >
            {loading ? 'Registrando...' : 'Registrarse'}
          </button>

          <div className="login-link">
            <p>¿Ya tienes cuenta? <a href="#" onClick={(e) => { e.preventDefault(); onGoToLogin && onGoToLogin(); }}>Inicia sesión aquí</a></p>
          </div>
        </form>
      </div>

      <div className="register-background">
        <div className="gradient-blob blob-1"></div>
        <div className="gradient-blob blob-2"></div>
        <div className="gradient-blob blob-3"></div>
      </div>
    </div>
  );
};

export default RegisterForm;
